export default "__VITE_PUBLIC_ASSET__de43c4f2__"